import { Component, Input, OnInit } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { IGenericCrudConfiguration } from 'src/app/libs/components/generic-crud/generic-crud.component';
import { Bom, Product, DraftableStateTypes, TId } from 'src/app/models';
import { MasterApiService } from 'src/app/services/master-api.service';
import { ProductsBomsEditComponent } from './products-boms-edit/products-boms-edit.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-products-boms',
    templateUrl: './products-boms.component.html',
    styleUrls: ['./products-boms.component.sass'],
    standalone: false
})
export class ProductsBomsComponent implements OnInit {
  @Input() productId: TId | undefined;

  config?: IGenericCrudConfiguration<Bom>;
  BomStates = DraftableStateTypes;

  product: Product;
  products: Product[];
  productBoms: Bom[];

  constructor(private api: MasterApiService, private translateService: TranslateService) {
    this.products = [];
    this.product = {} as Product;
    this.productBoms = [];

    this.BomStates.forEach(x => x.displayName = this.translateService.instant(`enumeration.DraftableStateTypes.${x.name}`));
  }

  async getProduct(): Promise<void> {
    const product: any = await firstValueFrom(this.api.getProduct(this.productId!))
    this.product = product;
    this.products.push(product);
  }

  async getProductBoms(): Promise<void> {
    this.productBoms = await firstValueFrom(this.api.getBomsByProductId( { productId: this.productId! }))
  }

  async ngOnInit(): Promise<void>{
    await this.getProduct();
    await this.getProductBoms();
    this.config = {
      name: this.api.resources.product.boms.resourceName,
      resource: this.api.resources.product.boms,
      data: this.productBoms,
      isSearcherVisible: false,
      editComponent: {component: ProductsBomsEditComponent, inputPrms: { product: this.product }},
      entityFields: {
        version: {isLink: true},
        productId: {
          isLink: true,
          lookup: {
            dataSource: this.products,
            displayExpr: 'name',
            valueExpr: 'id'
          }
        },
        stateId: {
          lookup: {
            dataSource: this.BomStates,
            displayExpr: 'displayName',
            valueExpr: 'id'
          }
        }
      },
      crudButtons: {
        canCreate: false,
        canEdit: true,
        canDelete: false,
        canCopy: false,
      }
    }
  }
}
